import { useState, useEffect, useRef } from "react";
import React from "react";
import {meter, meterReading, user, workOrder, issueTracking} from "../../api";
import { toast } from "react-toastify";
import Select, { StylesConfig } from "react-select";
import {

  getStatusColor,
  printLocation,
  renderImage,
  formatDateOnly,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";

import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader, CardFooter } from "../../components/card/card";

import Dropdown from "react-bootstrap/Dropdown";
import { format } from "date-fns";
import ImageViewer from "../../components/ImageViewer";


function IssueTrackingDetail() {
  const { id } = useParams();
  const editMode = !!id;

  const {config, getLocationName} = useAuth();
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "rgba(0, 0, 0, 0.48)",
      borderColor: "var(--bs-border-color)",
    }),
    input: (styles) => ({
      ...styles,
      color: "white",
    }),
    menu: (styles) => ({
      ...styles,
      color: "grey",
    }),
  };


  const [signatureConfirmation, setSignatureConfirmation] = useState(false);
  const [status, setStatus] = useState("");
  const [options, setOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [locations, setLocations] = useState([]);
  const [users, setUsers] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsRequest, setAttachmentsRequest] = useState([]);
  const [choosenSignature, setChoosenSignature] = useState([]);
  const [tempStatus, setTempStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [assignType, setAssignType] = useState("individual");
  const [isDataFound, setIsDataFound] = useState(true);
  const [newReading, setNewReading] = useState({
    reading_value: "",
    reading_date: "",
    notes: "",
  });
  const [dataToSend, setDataToSend] = useState({
    asset: "",
    created_at: "",
    description: "",
    title: "",
    type: "",
    location: "",
    status: "",
    work_orders: [],
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }


  async function getMasterData() {
    setIsLoading(true);
    try {
      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  async function getUsers() {
    const getUser = user.list({});
    const result = await getUser;
    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setUsers(data);
    }
  }

  useEffect(() => {
    getMasterData();
    getUsers();
  }, [id]);

  async function getRecord() {
    const result = await issueTracking.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;
      if(!data) {
        setIsDataFound(false);
        return;
      }

      const defaultValue = {
        asset: data.asset?.asset_name,
        created_at: format(new Date(data.created_at), "yyyy-MM-dd"),
        status: data.status,
        description: data.description,
        title: data.title,
        type: data.type?.name,
        work_orders: data.work_order,
      };
   

      if(data.asset?.location) {
        const locationName = [];
        function generateLocation(location) {
          locationName.push(location.location_name);
          if (location.parent_location) {
            generateLocation(location.parent_location);
          }
        }
  
        generateLocation(data.asset.location);
        setLocations(locationName.reverse());
      }else if(data.location) {
        const locationName = [];
        function generateLocation(location) {
          locationName.push(location.location_name);
          if (location.parent_location) {
            generateLocation(location.parent_location);
          }
        }
        generateLocation(data.location);
        setLocations(locationName.reverse());
      }


      if (data.attachments) {
        // check if data.attachments is an object
        if (typeof data.attachments !== "object") {
          console.error("attachments is not an object");
          return;
        }
        const att = [];
        if (data.attachments)
          Object.keys(data.attachments).forEach((key) => {
            if (data.attachments[key]) {
              const name = key.split("_")[3];
              const type = key.split("_")[2];
              const url = renderImage(
                `machine/attachment/${data.attachments[key]}`
              );
              const attachment = {
                name: name,
                type,
                url,
                value: data.attachments[key],
              };
              att.push(attachment);
              // if (!isRequest) {
              //
              // }else{
              //   attReq.push(attachment)
              // }
            }
          });
        setAttachments(att);
      }
      
      setOptions(
          ["Open", "In Progress", "On Hold", "Resolved"]
      );
      setStatus(data.status);
      setDataToSend(defaultValue);
    }
  }

  const handleChangeStatus = async (v) => {
    try {
      let result;

      setIsLoading(true)
    
          result = await issueTracking.updateStatus(id, { status: v });
          if (result.ok) {
            toast.success("Status updated");
          } else {
            toast.error("Status failed to update");
          }
          setStatus(v);

          getRecord();
        
      
      setIsLoading(false)

    } catch (e) {
      toast.error(e.message);
    }

  };
 
  

  

  return (
    <Card className={"form-darker"}>
   

      <LoadingIndicator open={isLoading} />
      <CardHeader>
        <div className={"d-flex justify-content-between"}>
          <div>Issue Tracking Information</div>
         
        </div>
      </CardHeader>

      {!isDataFound && <CardBody>
        <div className="row">
          <div className="col-md-12">
            <div className="text-center text-muted py-4 cursor-pointer">
              <i className="fa fa-list fa-3x mb-3"></i>
              <p>No data found for this issue tracking.</p>
            </div>
          </div>
        </div>
      </CardBody>}
    
      

      {isDataFound && <CardBody>
        <div className="row g-1 mb-3 d-flex justify-content-end ">
          <div className="w-25">
            <Dropdown onSelect={handleChangeStatus}>
              <Dropdown.Toggle
                id="dropdown-basic"
                className={`w-100 btn btn-outline-${getStatusColor(status)
                  }`}
                variant="outline"
              >
                {status}
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-100">
                {options.map((v, i) => (
                  <Dropdown.Item eventKey={v} key={v}>
                    {v}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>


        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="workOrderTitle" className="form-label">
              Title
            </label>
            <input
              disabled
              value={dataToSend["title"]}
              className="form-control"
              required
            />
          </div>

      

             
          <div className="mb-3">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              disabled
              value={dataToSend["description"]}
              className="form-control"
              style={{ width: "100%", backgroundColor: "#0000007a" }}
                 
            />
          </div>
          

          <div className="mb-3">
            <label htmlFor="type" className="form-label">
              Type
            </label>
            <input
              disabled
              value={dataToSend["type"]}
              className="form-control"
                 
            />
          </div>

          {locations.map((l, index) => {
            return (
              <div key={index} className="mb-3">
                <label htmlFor="location" className="form-label">
                  {getLocationName(index)}
                </label>
                <input
                  disabled
                  value={l}
                  className="form-control"
                  
                />
              </div>
            );
          })}


          <div className="mb-3">
            <label htmlFor="asset" className="form-label">
              Asset
            </label>
            <input
              disabled
              value={dataToSend.asset}
              className="form-control"
                  
            />
          </div>
          

          <div className="mb-3">
            <label htmlFor="startDate" className="form-label">
              Created Date
            </label>
            <input
              disabled
              value={dataToSend["created_at"]}
              className="form-control"
              required
            />
          </div>
       

          

           
        </div>
        

           
        {attachments.length > 0 && (
          <div className="mb-3">
            <Card>
              <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                Attachments
              </CardHeader>
              <CardBody>
                <div className="row">
                  {attachments.map((attachment, index) => (
                    <div key={index} className={"col-sm-4 position-relative"}>
                      {attachment.type === "image" && (
                        <ImageViewer
                          staticImage={attachment.url}
                          className={"img-fluid w-100"}
                          alt=""
                        />
                      )}
                      {attachment.type === "video" && (
                        <video
                          src={attachment.url}
                          className={"img-fluid w-100"}
                          width={"100%"}
                          controls
                        />
                      )}
                      {attachment.type === "pdf" && (
                        <iframe
                          src={attachment.url}
                          className={" w-100"}
                          width={"100%"}
                          height={"350px"}
                        />
                      )}
                      {attachment.type === "other" && (
                        <a
                          href={attachment.url}
                          target={"_blank"}
                          rel="noreferrer"
                          style={{
                            height: "200px",
                            paddingTop: "95px",
                            display: "block",
                          }}
                          className={
                            "border-theme border-1 border w-100 text-center"
                          }
                        >
                          Download the File
                        </a>
                      )}

                      <div className="my-2">
                        <input
                          type="text"
                          className={"form-control"}
                          value={attachment.name}
                          readOnly
                          disabled
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </div>
        )}


        

        <Card>
          <CardHeader>
            Work Orders for Issue Tracking
          </CardHeader>
          <CardBody>
            {
              dataToSend?.work_orders.length > 0 && dataToSend?.work_orders.map((work_order) => (
                <div key={work_order.id}>
                  <div className="row">
                    <div className="col-md-6">
                      <p className="text-bold">#{work_order.number} - {work_order.title} -  <span
                        className={`badge border border-${getStatusColor(
                          work_order.status
                        )} text-${getStatusColor(work_order.status)}`}
                      >
                        {work_order.status}
                      </span></p>
                      <p className="text-muted mb-0">Start Date: {formatDateOnly(new Date(work_order.start_date))}</p>
                      <p className="text-muted mb-0">Due Date: {formatDateOnly(new Date(work_order.due_date))}</p>

                    </div>
                    <div className="col-md-6">
                      <div className="text-end">
                        <button onClick={() => navigate(`/work-order/detail/${work_order.id}`)} className="btn btn-primary">View Work Order</button>
                      </div>
                    </div>

                  </div>
                  <hr />
                </div>
              ))
            }
                
            {(dataToSend?.work_orders.length == 0) && (
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="text-center text-muted py-4 cursor-pointer">
                      <i className="fa fa-list fa-3x mb-3"></i>
                      <p>No work orders found for this issue tracking.</p>
                      <button onClick={() => navigate(`/work-order/add?issue_tracking_id=${id}`)} className="btn btn-outline-primary ">Add work orders to this issue tracking.</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
                
      
     
      </CardBody>
      }
    </Card>
  );
}

export default IssueTrackingDetail;
